import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, SummaryItem } from '../../../../tms-shared';
import { RoleDetails } from '../../models';
import { RoleService } from '../../services';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrl: './role.component.scss',
})
export class RoleComponent extends BaseComponent implements OnInit {
  readonly detailsHeader = $localize`Details`;
  readonly menusHeader = $localize`Menus`;

  model$: Observable<RoleDetails>;

  private id: string;

  constructor(
    private roleService: RoleService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.getModel();
  }

  summaryTopItems(model: RoleDetails): SummaryItem[] {
    return [
      { label: $localize`Name`, value: model.name },
      { label: $localize`Description`, value: model.description },
    ];
  }

  getModel(): void {
    if (this.id) {
      this.model$ = this.roleService.edit(this.id).pipe(takeUntil(this.destroy$));
    }
  }
}
